import React from 'react';
import './OrganizationChart.css';
import { buildFlowTreeNode, buildTopDownTreeNode } from './buildOrgChartTree';

const OrganizationChart = ({
  nodes = [],
  expandedNodes,
  onToggle,
  layout,
  onNavigate,
}) => {
  if (!nodes.length) {
    return (
      <div className="py-16 text-center text-slate-500" data-testid="org-chart-empty">
        <p className="font-medium">No organization chart data matches the current filters.</p>
        <p className="text-sm mt-1">Try changing organization, department, team, or search filters.</p>
      </div>
    );
  }

  if (layout === 'horizontal') {
    return (
      <div className="inline-block min-w-full py-4" data-testid="organization-chart">
        <div className="org-flow">
          {nodes.map((node) => buildFlowTreeNode(node, expandedNodes, onToggle, onNavigate))}
        </div>
      </div>
    );
  }

  return (
    <div className="inline-block min-w-full py-4" data-testid="organization-chart">
      <ul className="org-tree">
        {nodes.map((node) => buildTopDownTreeNode(node, expandedNodes, onToggle, onNavigate))}
      </ul>
    </div>
  );
};

export default OrganizationChart;
